/**
 * Shared toast notification — reusable across pages.
 * BOM spreadsheet and other modules historically inlined their own toast;
 * prefer this component for new call sites.
 */
import { useEffect } from 'react'

export interface ToastProps {
  message: string | null
  /** Auto-hide duration in ms (default 3500). Pass 0 to disable auto-hide. */
  durationMs?: number
  onDismiss?: () => void
}

export function Toast({ message, durationMs = 3500, onDismiss }: ToastProps) {
  useEffect(() => {
    if (!message || !onDismiss || durationMs <= 0) return
    const t = window.setTimeout(() => onDismiss(), durationMs)
    return () => window.clearTimeout(t)
  }, [message, durationMs, onDismiss])

  if (!message) return null

  return (
    <div
      role="status"
      className="fixed bottom-6 right-6 z-50 rounded-md bg-slate-900 px-4 py-2.5 text-xs font-semibold text-white shadow-2xl print:hidden"
    >
      {message}
    </div>
  )
}
